
import { defineComponent, ref } from 'vue'
import { ICarouselCard } from 'vue-carousel-card'
import { CarouselCard, CarouselCardItem } from 'vue-carousel-card'
import 'vue-carousel-card/styles/index.css'

export default defineComponent({
  components: { CarouselCard, CarouselCardItem },
  props: {
    listProducts: {
      type: Array,
      default: () => []
    },
  },
  setup () {
    const carouselCardRef = ref<ICarouselCard>()
    const changeHandle = (index: number) => {
      return index
    }
    const getBeerImage = (img) => {
      try {
        return require(`@/assets/images/flags/${img}.png`)
      } catch (e) {
        return require("@/assets/images/flags/error.png")
      }
    }
    const next = () => {
      carouselCardRef.value?.next()
    }
    const prev = () => {
      carouselCardRef.value?.prev()
    }
    const setToFirst = () => {
      carouselCardRef.value?.setActiveItem(0)
    }
    return {
      getBeerImage,
      carouselCardRef,
      changeHandle,
      next,
      prev,
      setToFirst
    }
  }
})
